/* footer-animation JavaScript/jQuery */
jQuery(function( $ ) {

    sb_when( '#affiliate-links-slider', function() {

        // Affiliate Links
        var affiliateLinksSlider = $( '#affiliate-links-slider' ),
            affiliateLinksSlides = affiliateLinksSlider.children( '.slide' ),
            affiliateLinksHandle = $( '#affiliate-links-handle' );

        affiliateLinksSlider.on( 'init', function( event, slick ){
            // load slick, but hide contents.
            if ( Cookies.get( 'affiliate-links-hidden' ) != undefined ) {
                setTimeout( function() {
                    $( '#affiliate-links' ).collapse();
                }, 300 );
            }
        });

        affiliateLinksHandle.on( 'click', function() {
            if ( $( '#affiliate-links' ).hasClass( 'show' ) ) {
                Cookies.set( 'affiliate-links-hidden', true );
            } else {
                Cookies.remove( 'affiliate-links-hidden' );
                $( window ).trigger( 'resize' );
            }
        });

        affiliateLinksSlider.slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: false,
            mobileFirst: true,
            arrows: false,
            autoplay: false,
            pauseOnHover: true,
            slidesToShow: 2,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                        prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                        prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        arrows: true,
                        prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                }
            ],
        });

        affiliateLinksSlider.onScrollIntoView(
            function() {
                if ( $( '#affiliate-links' ).hasClass( 'show' ) ) {
                    affiliateLinksSlider.slick( 'next' );
                }
            },
            function() {
                if ( $( '#affiliate-links' ).hasClass( 'show' ) ) {
                    let prevSlideIndex = affiliateLinksSlider.slick( 'slickCurrentSlide' ) == 0
                        ? affiliateLinksSlider.slick( 'slickCurrentSlide' ) - 1
                        : affiliateLinksSlides.length - 1;
                    affiliateLinksSlider.slick( 'slickGoTo', prevSlideIndex, false );
                }
            }
        );
    });

	// collaborator links slider
	sb_when( '#collaborator-links-slider', function() {

        // Affiliate Links
        var collaboratorLinksSlider = $( '#collaborator-links-slider' ),
            collaboratorLinksSlides = collaboratorLinksSlider.children( '.slide' );
            // affiliateLinksHandle = $( '#collaborator-links-handle' );

        // collaboratorLinksSlider.on( 'init', function( event, slick ){
        //     // load slick, but hide contents.
        //     if ( Cookies.get( 'collaborator-links-hidden' ) != undefined ) {
        //         setTimeout( function() {
        //             $( '#collaborator-links' ).collapse();
        //         }, 300 );
        //     }
        // });
		//
        // collaboratorLinksHandle.on( 'click', function() {
        //     if ( $( '#collaborator-links' ).hasClass( 'show' ) ) {
        //         Cookies.set( 'collaborator-links-hidden', true );
        //     } else {
        //         Cookies.remove( 'collaborator-links-hidden' );
        //         $( window ).trigger( 'resize' );
        //     }
        // });

        collaboratorLinksSlider.slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: false,
            mobileFirst: true,
            arrows: false,
            autoplay: false,
            pauseOnHover: true,
            slidesToShow: 1,
            // centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        // arrows: true,
                        // prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        // nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        // arrows: true,
                        // prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        // nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        // arrows: true,
                        // prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        // nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                }
            ],
        });

        collaboratorLinksSlider.onScrollIntoView(
            function() {
                if ( $( '#collaborator-links' ).hasClass( 'show' ) ) {
                    collaboratorLinksSlider.slick( 'next' );
                }
            },
            function() {
                if ( $( '#collaborator-links' ).hasClass( 'show' ) ) {
                    let prevSlideIndex = collaboratorLinksSlider.slick( 'slickCurrentSlide' ) == 0
                        ? collaboratorLinksSlider.slick( 'slickCurrentSlide' ) - 1
                        : collaboratorLinksSlides.length - 1;
                    collaboratorLinksSlider.slick( 'slickGoTo', prevSlideIndex, false );
                }
            }
        );
    });

    sb_when( '#news-ticker-slider', function() {
        var newsTickerSlider = $( '#news-ticker-slider' ),
            newsTickerSlides = newsTickerSlider.children( '.slide' );

            newsTickerSlider.slick({
                dots: true,
                arrows: true,
                autoplay: true,
                prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
            });
    });



});
